<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-4 col-sm-4 text-center">
        <stats-card2>
          <div class="icon-big text-center icon-info" slot="header">
            <i class="fa fa-users"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Obligados</p>
            {{obligados}}
          </div>
          <div class="stats" slot="inicial">
            <p>{{obligadosIn}}</p>
          </div>
          <div class="stats" slot="anual">
            <p>{{obligadosAn}}</p>
          </div>
          <div class="stats" slot="final">
            <p>{{obligadosFi}}</p>
          </div>
        </stats-card2>
      </div>
      <div class="col-lg-4 col-sm-4 text-center">
        <stats-card2>
          <div class="icon-big text-center icon-success" slot="header">
            <i class="fa fa-file"></i>

          </div>
          <div class="numbers" slot="content">
            <p>Declaraciones</p>
            {{declaraciones}}
          </div>
          <div class="stats" slot="inicial">
            <p>{{this.rinicial}}</p>
          </div>
          <div class="stats" slot="anual">
            <p>{{this.ranual}}</p>
          </div>
          <div class="stats" slot="final">
            <p>{{this.rfinal}}</p>
          </div>
        </stats-card2>


      </div>
      <div class="col-lg-4 col-sm-4 text-center">
        <stats-card2>
          <div class="icon-big text-center icon-danger" slot="header">
            <i class="fa fa-users"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Faltantes</p>
            {{faltantes}}
          </div>
          <div class="stats" slot="inicial">
            <p>{{faltantesIn}}</p>
          </div>
          <div class="stats" slot="anual">
            <p>{{faltantesAn}}</p>
          </div>
          <div class="stats" slot="final">
            <p>{{faltantesFi}}</p>
          </div>
        </stats-card2>

      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="card card-circle-chart">
          <div class="card-header">
            <h4 class="card-title">Declaraciones por día</h4>
            <p class="category">Se muestra la última semana</p>
          </div>
          <div class="card-content">
            <div id="chartStock" class="ct-chart"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4" @click="cumplimiento">
        <circle-chart-card :percentage="porcentaje" title="Avance Global" :avance="declaraciones" :total="obligados" description="" @click="cumplimiento">
        </circle-chart-card>
      </div>
    </div>
    <div class="row" v-if="this.getKey('permisos').includes(19)">

      <div class="col-lg-4 col-sm-4 ">
        <a :href="'#/alertas/bitacora'">
          <stats-card>
            <div class="icon-big text-left icon-info" slot="header">
              <i class="fa fa-book"></i>
            </div>
            <div class="numbers titulos" slot="content">
              <p>Bitácora</p>
              <p class="category">Declaraciones Consultadas</p>
            </div>
          </stats-card>
        </a>
      </div>

      <!-- <div class="col-lg-4 col-sm-4 text-center">
        <a :href="'#/alertas/modificadas'">
          <stats-card>
            <div class="icon-big text-center icon-success" slot="header">
              <i class="fa fa-file"></i>
            </div>
            <div class="numbers titulos" slot="content">
              <p>Modificadas</p>
              <p class="category">Declaraciones Reactivadas</p>
            </div>
          </stats-card>
        </a>
      </div> -->

      <div class="col-lg-4 col-sm-4 text-center">
        <a :href="'#/admin/movimientos'">
          <stats-card>
            <div class="icon-big text-center icon-warning" slot="header">
              <i class="fa fa-check-double"></i>
            </div>
            <div class="numbers titulos" slot="content">
              <p>Vo.Bo. Correcciones</p>
              <p class="category">Aprobar Correcciones</p>
            </div>
          </stats-card>
        </a>
      </div>

    </div>


  </div>
</template>
<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import StatsCard2 from 'src/components/UIComponents/Cards/StatsCard2.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import chartist_tooltip from 'chartist-plugin-tooltips';

  export default {
    components: {
      StatsCard,
      StatsCard2,
      ChartCard,
      CircleChartCard
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        $Chartist: null,
        obligados: '',
        min: 0,
        max: 0,
        faltantes: '',
        porcentaje: 0,
        declaraciones: '',
        plugins: null,
        rinicial: 0,
        ranual: 0,
        rfinal: 0,
        obligadosIn: 0,
        obligadosAn: 0,
        obligadosFi: 0,
        faltantesIn: 0,
        faltantesAn: 0,
        faltantesFi: 0
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions() {
        if (!(this.getKey('role') != 0)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }

      },
      initStockChart() {

        const dataStock = {
          labels: [],
          series: [
            []
          ]

        }
        const optionsStock = {
          lineSmooth: false,
          axisY: {
            offset: 40,
            labelInterpolationFnc(value) {
              return `${value}`
            }

          },
          low: this.min,
          height: '260px',
          high: this.max,
          classNames: {
            point: 'ct-point ct-green',
            line: 'ct-line ct-green'
          },
          plugins: [this.$Chartist.plugins.tooltip()]
        }
        const temp = [];
        this.$http.get("semana").then(
          response => {
            $.each(response.data, function (key, value) {
              dataStock.labels.push(value.date);
              temp.push(value.total);

            });
            dataStock.series[0] = temp;
            dataStock.labels.reverse()
            dataStock.series[0].reverse()
            this.$Chartist.Line('#chartStock', dataStock, optionsStock)
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getDatos() {
        this.$http.get("tableroGlobales2").then(
          response => {
            this.faltantes = this.group1k(response.data.faltantes)
            this.declaraciones = this.group1k(response.data.declaraciones)
            this.obligados = this.group1k(response.data.declarantes)
            this.porcentaje = parseFloat((response.data.porcentaje).toString().substring(0, 5));
            this.rinicial = this.group1k(response.data.desglosado[2].count)
            this.rfinal = this.group1k(response.data.desglosado[1].count)
            this.ranual = this.group1k(response.data.desglosado[0].count)
            this.faltantesIn = this.group1k(response.data.decIni - response.data.desglosado[2].count)
            this.faltantesAn = this.group1k(response.data.decAn - response.data.desglosado[0].count)
            this.faltantesFi = this.group1k(response.data.decFin - response.data.desglosado[1].count)
            this.obligadosIn = this.group1k(response.data.decIni)
            this.obligadosAn = this.group1k(response.data.decAn)
            this.obligadosFi = this.group1k(response.data.decFin)

          },
          error => {
            this.StepError(error);
          }
        );
      },
      cumplimiento() {
        this.$router.push('/reportes/cumplimiento');
      },
      /* group1k(s) {
          let s1 = s.toString()
          if(s1.length > 3){
            if(s1.length == 6){
                s1 = s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('')
                return s1.substring(1,s1.length);
            }else{
              return s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('');
            }

          }
          else
            return s1
      } */
    },
    created() {
      this.checkPermissions()
      this.getDatos()
      if (this.getKey('permisos').includes(18)) {
        this.min = 10;
        this.max = 1600;
      } else {
        this.min = 0;
        this.max = 500;
      }
    },
    async mounted() {
      const Chartist = await import('chartist')
      this.$Chartist = Chartist
      this.initStockChart()
      this.plugins = [this.$Chartist.plugins.tooltip()]
    }

  }

</script>
<style>
  .chartist-tooltip {
    position: absolute !important;
    background: rgba(0, 0, 0, 0.6) !important;
    color: white !important;
    padding: 0px 10px !important;
    border-radius: 5px !important;
  }

  .titulos {
    text-align: left !important;
  }

  .datos {
    margin-bottom: 0px !important;
    text-align: center !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Tablero2.vue